import React from 'react'

import { StyledFlex } from './FooterActionsStyled'

const FooterActionsFlex = () => (
  <StyledFlex />
)

export default FooterActionsFlex
